export default __webpack_public_path__ + "static/media/guide-badge-2025.92e6c842.svg";